<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/bad' }">{{$t('common.home')}}</el-breadcrumb-item>
          <el-breadcrumb-item>{{$t('saledFeedback.saledFeedback')}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-row class="search-row">
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('saledFeedback.orderNo')}}:</div>
            <div class="flex1">
              <el-input :placeholder="$t('common.pleaseInput')" clearable v-model="queryInfo.orderId" size="small"
                @keyup.enter.native="searchList">
              </el-input>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('common.createStartDate')}}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeStart" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')">
              </el-date-picker>
            </div>
          </el-col>
          <el-col :span="4" class="display-row">
            <div class="query-title">{{$t('common.createEndDate')}}:</div>
            <div class="flex1">
              <el-date-picker clearable v-model="queryInfo.createTimeEnd" type="date" size="small" format="yyyy-MM-dd"
                value-format="yyyy-MM-dd" :placeholder="$t('common.selectDate')">
              </el-date-picker>
            </div>
          </el-col>

        </el-row>
        <el-row class="search-row">
          <el-col :span="6" class="display-row">
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 0}"
              @click="quickSearchList('',index = 0)">{{$t('common.all')}}</el-button>
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 1}"
              @click="quickSearchList('0',index = 1)">{{$t('saledFeedback.unreply')}}<span
                class="lx-red">({{orderData.notReplyCount}})</span></el-button>
            <el-button class="search-btn btn-white" :class="{lxBtnGreenDeep: curIndex === 2}"
              @click="quickSearchList('1',index = 2)">{{$t('saledFeedback.replied')}}</el-button>
          </el-col>
          <el-col :span="18" class="display-row">
            <div style="text-align: right; width: 100%; padding-right: 10px">

              <el-button class="search-btn btn-gray" @click="queryInfoClear">{{$t('common.reset')}}</el-button>
              <el-button class="search-btn btn-blue" @click="searchList">{{$t('common.search')}}</el-button>
              <el-button class="search-btn btn-green" @click="apply">{{$t('saledFeedback.apply')}}</el-button>
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col" style="padding:10px">
        <el-table :header-cell-style="tableStyle.headerStyle" :cell-style="tableStyle.cellStyle" :data="messageList" border>
          <el-table-column type="index" align="center" :label="$t('wzbg.wz6')" width="60"></el-table-column>
          <el-table-column prop="id" :label="$t('saledFeedback.orderNo')" align="center" v-if="false">
          </el-table-column>
          <el-table-column prop="orderId" align="center" :label="$t('saledFeedback.orderNo')">
          </el-table-column>
          <el-table-column prop="createTime" :label="$t('common.createDate')" align="center" sortable :index="indexMethod"
            :formatter="formatDate">
          </el-table-column>
          <el-table-column prop="badPicture1" :label="`${$t('saledFeedback.badImg')}(1)`" align="center" width="115px">
            <template v-slot="scope">
              <img @click="imgclick(scope.row.badPicture1,true)" v-if="scope.row.badPicture1&&scope.row.badPicture1.length>0"
                :src="scope.row.badPicture1" alt="" class="list-image" style="width: 70px;height: 60px;">
              <img v-else src="../../assets/images/default.png" alt="" class="list-image" style="width: 70px;height: 60px;">
            </template>
          </el-table-column>
          <el-table-column prop="badPicture2" :label="`${$t('saledFeedback.badImg')}(2)`" align="center" width="115px">
            <template v-slot="scope">
              <img @click="imgclick(scope.row.badPicture2,true)" v-if="scope.row.badPicture2&&scope.row.badPicture2.length>0"
                :src="scope.row.badPicture2" alt="" class="list-image" style="width: 70px;height: 60px;">
              <img v-else src="../../assets/images/default.png" alt="" class="list-image" style="width: 70px;height: 60px;">
            </template>
          </el-table-column>
          <el-table-column prop="badPicture3" :label="`${$t('saledFeedback.badImg')}(3)`" align="center" width="115px">
            <template v-slot="scope">
              <img @click="imgclick(scope.row.badPicture3,true)" v-if="scope.row.badPicture3&&scope.row.badPicture3.length>0"
                :src="scope.row.badPicture3" alt="" class="list-image" style="width: 70px;height: 60px;">
              <img v-else src="../../assets/images/default.png" alt="" class="list-image" style="width: 70px;height: 60px;">
            </template>
          </el-table-column>
          <el-table-column prop="badPicture3" :label="`${$t('saledFeedback.badImg')}(4)`" align="center" width="115px">
            <template v-slot="scope">
              <img @click="imgclick(scope.row.badPicture4,true)" v-if="scope.row.badPicture4&&scope.row.badPicture4.length>0"
                :src="scope.row.badPicture4" alt="" class="list-image" style="width: 70px;height: 60px;">
              <img v-else src="../../assets/images/default.png" alt="" class="list-image" style="width: 70px;height: 60px;">
            </template>
          </el-table-column>
          <el-table-column prop="remark" :label="$t('saledFeedback.applyDetail')">
          </el-table-column>
          <el-table-column prop="status" sortable :index="indexMethod" align="center" :label="$t('common.state')">
            <template v-slot="scope">
              {{ typeDetailShow(scope.row.status) }}
            </template>
          </el-table-column>
          <el-table-column prop="replyTime" :label="$t('saledFeedback.replyDate')" align="center" sortable :index="indexMethod"
            width="160" :formatter="formatDate">
          </el-table-column>
          <el-table-column prop="replyRemark" :label="$t('saledFeedback.replyContent')">
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="queryInfo.pageNum"
          :page-sizes="[5, 10, 20, 50, 100]" :pager-count="5" :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </table-con>
    <!-- 回复 -->
    <el-dialog :title="$t('saledFeedback.apply')" :visible.sync="replyDialogVisible" width="50%" @close="replyDialogClose">
      <el-form :model="replyInfos" :rules="rules" ref="replyInfoRef" label-width="120px" class="demo-replyInfo">
        <el-form-item :label="$t('saledFeedback.orderNo')" prop="orderId">
          <el-input v-model="replyInfos.orderId" size="small" style="width: 90%"></el-input>
        </el-form-item>
        <el-form-item :label="$t('saledFeedback.badImg')">
          <!-- <el-upload class="editor-slide-upload" action="https://oytqc-oss.oss-cn-qingdao.aliyuncs.com" :data="imgDataObj"
            :multiple="true" :file-list="listObj" :show-file-list="true" list-type="picture-card" accept="image/png,image/jpeg"
            :on-remove="handleImgRemove" :on-success="handleImgSuccess" :before-upload="beforeImgUpload" :limit="9">
            <el-button size="small" type="primary">{{$t('saledFeedback.clickUpload')}}</el-button>
          </el-upload> -->
          <my-upload v-model="listObj"  class="editor-slide-upload" mode="array" :keyObject="{url:'url',name:'name'}" accept=".png,.jpeg" :limit="9"></my-upload>
        </el-form-item>
        <el-form-item :label="$t('saledFeedback.applyDetail')" prop="remark">
          <el-input type="textarea" v-model="replyInfos.remark" size="small" style="width: 90%"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="form-btn btn-blue" @click="replySave">{{$t('common.confirm')}}</el-button>
        <el-button class="form-btn btn-gray" @click="clearReplyForm">{{$t('common.cancel')}}</el-button>
      </div>
    </el-dialog>
    <!--    图片放大-->
    <el-dialog title="" :visible.sync="visible" width="30%" show-close center>
      <img width="100%" height="auto" :src="imgurl" alt="" class="list-image">
      <!--    <img :src="this.$store.state.imgurl" alt="">-->
    </el-dialog>
  </div>
</template>

<script>
import Oss from '../../assets/js/oss.js';
import tableCon from '../../views/tableContainer'

export default {
  components: { tableCon },
  data () {
    return {
      curIndex: 0, // 默认选中第0个
      visible: false,
      imgurl: '',
      listObj: [],
      imgDataObj: {
        policy: '',
        signature: '',
        key: '',
        ossaccessKeyId: '',
        dir: '',
        host: '',
        timeStamp: ''
      },
      replyInfos: {
        orderId: '',
        remark: '',
        badPicture1: '',
      },
      rules: {
        orderId: [
          { required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' }
        ],
        remark: [
          { required: true, message: this.$t('common.pleaseInput'), trigger: 'blur' }
        ]
        // badPicture1:[
        //     {required:true,message:'不良图片至少上传一张',trigger:'blur'}
        // ]
      },
      queryInfo: {
        orderId: '',
        status: '',
        createTimeStart: '',
        createTimeEnd: '',
        pageSize: 10,
        pageNum: 1
      },
      orderData: {
        notReplyCount: 0
      },
      badDateRangeValue: [],
      replyMessageInfo: {},  //回复页面显示表格所在行内容
      splitDialogVisible: false,
      dialogImageUrl: '',
      dialogVisible: false,
      messageInfo: {
        id: '',
        remindingContent: '',
        remindingTitle: '',
        remindingPicture: ''
      },    //回复新的内容
      messageTypeOptions: [
        {
          value: '1',
          label: this.$t('saledFeedback.orderMsg'),
        }, {
          value: '2',
          label: this.$t('saledFeedback.otherMsg'),
        }
      ],
      replyStatusOptions: [
        {
          value: '0',
          label: this.$t('saledFeedback.unreply'),
        }, {
          value: '1',
          label: this.$t('saledFeedback.replied'),
        }
      ],
      messageList: [],
      dialogFormVisible: false,
      replyDialogVisible: false,
      imgDialogVisible: false,
      total: 0,
    }
  },
  methods: {
    imgclick (url, visible) {
      this.visible = true
      this.imgurl = url
    },
    indexMethod (index) {
      return (this.pageNum - 1) * this.pageSize + index + 1;
    },
    handleImgSubmit () {
      var _this = this;
      let arr = []
      Object.keys(_this.listObj).map(v => {
          arr.push(_this.listObj[v].url)
      });
      if (!Oss.checkAllSuccess(_this.listObj)) {
        _this.$message(this.$t('saledFeedback.uploadRefreshTip'))
        return
      } else {
        if (arr.length > 9) {
          _this.$message.error(this.$t('saledFeedback.uploadNumberTip9'));
        } else {
          _this.replyInfos.pictureArr = arr;
          _this.$emit('successCBK', arr);
          _this.listObj = [];
          _this.imgDialogVisible = false;

        }
      }
    },
    handleImgRemove (file) {
      Oss.imgRemove(file, this.listObj);
    },
    handleImgSuccess (response, file) {
      Oss.imgSuccess(file, this.listObj, this.imgDataObj);
    },
    beforeImgUpload (file) {
      const _self = this;
      if (file.type !== 'image/jpeg' && file.type !== 'image/jpg' && file.type !== 'image/png') {
        _self.$message.error(this.$t('createOrder.createOrder74'));
        return false
      }
      let specialReg = /["<>:;,}{\\/\\|?*]/
      if (specialReg.test(file.name)) {
        _self.$message.error(this.$t('createOrder.specialChar'));
        return false
      }
      const fileName = file.uid;
      this.listObj[fileName] = {};
      return new Promise((resolve, reject) => {
        _self.$http.get('aliyun/oss/policy').then(response => {
          var num = "";   //定义编号
          for (var i = 0; i < 4; i++) //4位随机数，用以加在时间戳后面。
          {
            num += Math.floor(Math.random() * 10);
          }
          num = new Date().getTime() + num;  //时间戳，用来生成编号。
          _self.imgDataObj.policy = response.data.data.policy;
          _self.imgDataObj.signature = response.data.data.signature;
          _self.imgDataObj.ossaccessKeyId = response.data.data.accessKeyId;
          _self.imgDataObj.key = response.data.data.dir + '/bad/' + num + '${filename}';
          _self.imgDataObj.dir = response.data.data.dir + '/bad';
          _self.imgDataObj.host = response.data.data.host;
          _self.imgDataObj.timeStamp = num;
          file.timeStamp = num
          Oss.imgCompress(file, this.listObj, resolve, reject)
        }).catch(err => {
          reject(false)
        })
      })
    },
    formatDate (row, column, cellValue, index) {   //交易时间地方的时间格式化
      if (cellValue == null || cellValue == "") return "";
      let date = new Date(parseInt(cellValue) * 1000);//时间戳为10位需*1000，如果为13位的话不需乘1000。
      let Y = date.getFullYear() + '-';
      let M = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) + '-' : date.getMonth() + 1 + '-';
      let D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
      let h = date.getHours() < 10 ? '0' + date.getHours() + ':' : date.getHours() + ':';
      let m = date.getMinutes() < 10 ? '0' + date.getMinutes() + ':' : date.getMinutes() + ':';
      let s = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
      return Y + M + D + h + m + s;
    },
    handleSizeChange (newSize) {   //分页
      this.queryInfo.pageSize = newSize;
      this.getMessageList();
    },
    handleCurrentChange (newPage) {    //分页
      this.queryInfo.pageNum = newPage;
      this.getMessageList();
    },
    replySave () {    //保存回复内容按钮
      this.addReply();
    },
    clearReplyForm () {   //回复弹窗的取消按钮
      this.replyInfos.remark = "";
      this.replyDialogVisible = false;
    },
    async addReply () {    //添加回复
      this.handleImgSubmit();
      var my = this;
      this.$refs.replyInfoRef.validate(async function (valid) {
        if (valid) {
          var url = 'bad/create';
          const { data: res } = await my.$http.post(url, my.replyInfos);
          if (res.code == 200) {
            my.$message({
              type: 'success',
              message: res.message
            }),
              my.replyDialogVisible = false;
            my.getMessageList();
            my.getStatisticalNum();
          } else {
            my.$message({
              type: 'warning',
              message: res.message
            })
          }
        }
      })
    },
    searchList () {    //查询
      this.queryInfo.pageNum = 1;
      this.getMessageList();
      this.getStatisticalNum();
    },
    quickSearchList (val, index) {
      this.curIndex = index
      this.queryInfo.pageNum = 1;
      this.queryInfo.status = val;
      this.getMessageList();
      this.getStatisticalNum();
    },
    async getMessageList () {   //获取信息列表
      const { data: res } = await this.$http.get('bad/list', { params: this.queryInfo });
      this.messageList = res.data.list;
      this.total = res.data.total;
    },
    async getStatisticalNum () {      //获取
      const { data: res } = await this.$http.get("/bad/badCount");
      this.orderData = res.data;
    },
    queryInfoClear () {    //清空
      this.queryInfo = {
        createTimeStart: '',
        createTimeEnd: '',
        orderId: '',
        userName: '',
        pageSize: 10,
        pageNum: 1
      }
      this.badDateRangeValue = [];
    },
    typeDetailShow (status) {
      switch (status) {
        case '0':
          return this.$t('saledFeedback.unreply')
        case '1':
          return this.$t('saledFeedback.replied')
      }
    },
    apply () {     //回复
      this.replyDialogVisible = true;
      this.replyInfos = {
        orderId: '',
        remark: '',
      };
      this.listObj = []
      this.$nextTick(function () {
        this.$refs.replyInfoRef.clearValidate();
      })
    },
    replyDialogClose () {    //关闭回复弹窗
      this.replyDialogVisible = false;
    },
  },
  watch: {
    //监听时间选择器绑定值变化
    badDateRangeValue () {
      //解决时间选择器清空后 绑定值为null问题
      if (!this.badDateRangeValue) {
        this.badDateRangeValue = [];
        this.queryInfo.createTimeStart = '';
        this.queryInfo.createTimeEnd = '';
      } else {
        if (this.badDateRangeValue.length > 0) {
          this.queryInfo.createTimeStart = this.badDateRangeValue[0] + " 00:00:00";
          this.queryInfo.createTimeEnd = this.badDateRangeValue[1] + " 23:59:59";
        }
      }

    }
  },
  created () {
    this.getStatisticalNum();
    this.getMessageList();
  }
};
</script>

<style lang="less" scoped>
.role-page > .search-container {
  height: 60px !important;
}

.el-table .el-button--small {
  padding: 4px 10px;
}
</style>
